<template>
  <div>
    <div v-if="isEmbedded" class="device-position-container embedded">
      <div class="device-position-container-inner">
        <!-- 画布区域 -->
        <div class="canvas-panel">
          <div class="canvas-container" ref="canvasContainer">
            <!-- 背景图片 -->
            <div class="background-image" :style="backgroundImageStyle">
              <!-- 红色框（centerbox） -->
              <div class="centerbox" ref="centerbox" :style="centerboxStyle">
                <!-- 已放置的设备 -->
                <div
                  v-for="(device, index) in placedDevices"
                  :key="device.id"
                  class="placed-device"
                  :style="getDeviceStyle(device)"
                  @mousedown="handleDeviceMouseDown($event, device, index)"
                  @click.stop="handleDeviceClick(device)"
                >
                  <div
                    :class="[
                      'device-label',
                      {
                        'long-name': isLongDeviceName(device.name),
                        'is-offline': isDeviceOffline(device),
                      },
                    ]"
                  >
                    {{ device.name }}
                  </div>
                  <img
                    :src="getDeviceDisplayImage(device)"
                    :alt="device.name"
                    class="device-icon"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="isEmbedded" class="embedded-footer">
        <el-button type="primary" size="large" @click="handlePreview"
          >预览</el-button
        >
        <el-button type="success" size="large" @click="handleSave"
          >保存</el-button
        >
        <el-button type="warning" size="large" @click="handleModify"
          >修改</el-button
        >
        <el-button type="info" size="large" @click="handleCancel"
          >取消</el-button
        >
      </div>
    </div>

    <el-dialog
      v-else
      title="定义设备位置"
      :visible.sync="visible"
      width="90%"
      :close-on-click-modal="false"
      @close="handleClose"
      class="device-position-dialog"
    >
      <div class="device-position-container">
        <!-- 画布区域 -->
        <div class="canvas-panel">
          <div class="canvas-container" ref="canvasContainer">
            <!-- 背景图片 -->
            <div class="background-image" :style="backgroundImageStyle">
              <!-- 红色框（centerbox） -->
              <div class="centerbox" ref="centerbox" :style="centerboxStyle">
                <!-- 已放置的设备 -->
                <div
                  v-for="(device, index) in placedDevices"
                  :key="device.id"
                  class="placed-device"
                  :style="getDeviceStyle(device)"
                  @mousedown="handleDeviceMouseDown($event, device, index)"
                  @click.stop="handleDeviceClick(device)"
                >
                  <div
                    :class="[
                      'device-label',
                      {
                        'long-name': isLongDeviceName(device.name),
                        'is-offline': isDeviceOffline(device),
                      },
                    ]"
                  >
                    {{ device.name }}
                  </div>
                  <img
                    :src="getDeviceDisplayImage(device)"
                    :alt="device.name"
                    class="device-icon"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- 预览弹窗 - 全屏iframe -->
    <div
      v-if="previewVisible"
      class="fullscreen-iframe-wrapper"
      @click.self="handleClosePreview"
    >
      <div class="iframe-container">
        <iframe
          ref="previewIframe"
          :src="previewIframeUrl"
          class="preview-iframe"
          frameborder="0"
          allowfullscreen
        ></iframe>
        <div class="close-button" @click="handleClosePreview" title="关闭预览">
          <i class="el-icon-close"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { baseUrl } from "@/axios/baseUrl";
import router from "@/router";

export default {
  name: "DevicePositionEditor",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    backgroundImageUrl: {
      type: String,
      default: "",
    },
    backgroundImageId: {
      type: [String, Number],
      default: "",
    },
    greenhouseId: {
      type: String,
      default: "",
    },
    existingDevices: {
      type: Array,
      default: () => [],
    },
    isEmbedded: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      visible: false,
      placedDevices: [],
      initialPlacedDevices: [], // 保存初始设备位置，用于取消和重置
      previewVisible: false,
      // 画布尺寸
      canvasSize: {
        width: 0,
        height: 0,
      },
      // 背景图片尺寸（原始）
      backgroundSize: {
        width: 1920,
        height: 1080,
      },
      // 红色框位置和尺寸（相对于1920x1080背景图的百分比）
      // centerbox覆盖整个background-image区域（100%），设备位置基于相对于1920x1080背景图的百分比保存
      // 这样在任何分辨率下，background-image按16:9比例适配时，设备位置都能正确缩放
      centerboxConfig: {
        left: 0, // 0% - 相对于背景图左侧
        top: 0, // 0% - 相对于背景图顶部
        width: 1, // 100% - 覆盖整个背景图宽度
        height: 1, // 100% - 覆盖整个背景图高度
      },
      // 拖拽相关
      draggingDevice: null,
      draggingIndex: -1,
      draggingElement: null, // 保存正在拖拽的设备DOM元素
      dragOffset: { x: 0, y: 0 },
      isDragging: false,
      activeDeviceId: null,
    };
  },
  watch: {
    value(newVal) {
      this.visible = newVal;
      if (newVal) {
        this.init();
      }
    },
    visible(newVal) {
      this.$emit("input", newVal);
    },
  },
  computed: {
    backgroundImageStyle() {
      console.log(this.backgroundImageUrl);

      return {
        backgroundImage: `url(${this.getImageUrl(this.backgroundImageUrl)})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        width: "1200px",
        height: "675px",
      };
    },
    centerboxStyle() {
      const { left, top, width, height } = this.centerboxConfig;
      return {
        position: "absolute",
        left: `${left * 100}%`,
        top: `49px`,
        width: `${width * 100}%`,
        height: `425px`,
        // 显示红色边框，标识设备拖动区域
        border: "2px solid #ff0000",
        boxSizing: "border-box",
      };
    },
    // iframe预览页面URL
    previewIframeUrl() {
      const route = router.resolve("/");
      return route.href;
    },
  },
  mounted() {
    if (this.isEmbedded) {
      this.init();
    } else if (this.value) {
      this.visible = true;
      this.init();
    }
    window.addEventListener("resize", this.updateCanvasSize);
    // 监听来自预览页(iframe)的关闭消息
    window.addEventListener("message", this.handleIframeMessage);
  },
  watch: {
    isEmbedded: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.$nextTick(() => {
            this.init();
          });
        }
      },
    },
    existingDevices: {
      immediate: true,
      handler() {
        if (this.isEmbedded) {
          this.$nextTick(() => {
            this.init();
          });
        }
      },
    },
    previewVisible(newVal) {
      if (newVal) {
        // 预览弹窗打开时，阻止背景滚动
        document.body.style.overflow = "hidden";
        // 监听 ESC 键关闭
        document.addEventListener("keydown", this.handlePreviewEscKey);
      } else {
        // 预览弹窗关闭时，恢复背景滚动
        document.body.style.overflow = "";
        // 移除监听
        document.removeEventListener("keydown", this.handlePreviewEscKey);
      }
    },
  },
  methods: {
    isLongDeviceName(name) {
      return (name || "").length > 5;
    },
    isDeviceOffline(device) {
      return !device.onlineStatus;
    },
    init() {
      // 初始化已放置的设备
      if (this.existingDevices && this.existingDevices.length > 0) {
        this.placedDevices = JSON.parse(JSON.stringify(this.existingDevices));
        // 保存初始状态，用于取消和重置
        this.initialPlacedDevices = JSON.parse(
          JSON.stringify(this.existingDevices)
        );
      } else {
        this.placedDevices = [];
        this.initialPlacedDevices = [];
      }
      this.activeDeviceId = null;
      // 更新画布尺寸
      this.$nextTick(() => {
        this.updateCanvasSize();
      });
    },
    updateCanvasSize() {
      if (this.$refs.canvasContainer) {
        const rect = this.$refs.canvasContainer.getBoundingClientRect();
        this.canvasSize = {
          width: rect.width,
          height: rect.height,
        };
      }
    },
    getImageUrl(url) {
      if (!url) return "";
      if (url.startsWith("http://") || url.startsWith("https://")) {
        return url;
      }
      return baseUrl + url;
    },
    getDeviceDisplayImage(device) {
      if (!device || !device.image) return "";
      const baseImage = device.image;
      const isActive = this.activeDeviceId === device.id;
      const finalImageName = isActive ? `a_${baseImage}` : baseImage;
      return this.getDeviceImage(finalImageName);
    },
    getDeviceImage(imageName) {
      try {
        return require(`@/assets/img/equipment/${imageName}`);
      } catch (error) {
        console.error("加载设备图片失败:", error);
        return "";
      }
    },
    getDeviceStyle(device) {
      return {
        position: "absolute",
        left: `${device.x * 100}%`,
        top: `${device.y * 100}%`,
        transform: "translate(-50%, -50%)",
        cursor: "move",
      };
    },
    handleDeviceMouseDown(event, device, index) {
      event.preventDefault();
      this.activeDeviceId = device.id;
      this.draggingDevice = device;
      this.draggingIndex = index;
      this.draggingElement = event.currentTarget; // 保存设备DOM元素引用
      this.isDragging = true;

      const centerboxRect = this.$refs.centerbox.getBoundingClientRect();
      const deviceElement = event.currentTarget;
      const deviceRect = deviceElement.getBoundingClientRect();

      // 计算鼠标相对于设备中心点的偏移
      this.dragOffset = {
        x: event.clientX - (deviceRect.left + deviceRect.width / 2),
        y: event.clientY - (deviceRect.top + deviceRect.height / 2),
      };

      document.addEventListener("mousemove", this.handleDeviceMouseMove);
      document.addEventListener("mouseup", this.handleDeviceMouseUp);
    },
    handleDeviceMouseMove(event) {
      if (!this.isDragging || !this.draggingDevice) return;

      const centerbox = this.$refs.centerbox;
      if (!centerbox) return;

      const centerboxRect = centerbox.getBoundingClientRect();

      // 计算鼠标相对于centerbox的位置
      const mouseX = event.clientX - centerboxRect.left;
      const mouseY = event.clientY - centerboxRect.top;

      // 考虑拖拽偏移量，计算设备中心点的目标位置
      const targetX = mouseX - this.dragOffset.x;
      const targetY = mouseY - this.dragOffset.y;

      // 获取设备元素的实际尺寸（用于边界检查）
      let deviceHalfWidth = 25; // 默认设备图标宽度的一半（50px / 2）
      let deviceHalfHeight = 25; // 默认设备图标高度的一半（50px / 2）

      if (this.draggingElement) {
        const deviceRect = this.draggingElement.getBoundingClientRect();
        deviceHalfWidth = deviceRect.width / 2;
        deviceHalfHeight = deviceRect.height / 2;
      }

      // 严格限制在centerbox内，考虑设备尺寸
      // 确保设备的整个区域都在红框内
      const minX = deviceHalfWidth;
      const maxX = centerboxRect.width - deviceHalfWidth;
      const minY = deviceHalfHeight;
      const maxY = centerboxRect.height - deviceHalfHeight;

      // 限制设备中心点位置，确保设备完全在红框内
      const clampedX = Math.max(minX, Math.min(targetX, maxX));
      const clampedY = Math.max(minY, Math.min(targetY, maxY));

      // 更新设备位置（相对于centerbox的百分比）
      // 确保百分比值在有效范围内（0-1）
      this.draggingDevice.x = Math.max(
        0,
        Math.min(clampedX / centerboxRect.width, 1)
      );
      this.draggingDevice.y = Math.max(
        0,
        Math.min(clampedY / centerboxRect.height, 1)
      );
    },
    handleDeviceClick(device) {
      this.activeDeviceId = device.id;
    },
    handleDeviceMouseUp() {
      this.isDragging = false;
      this.draggingDevice = null;
      this.draggingIndex = -1;
      this.draggingElement = null; // 清除设备元素引用
      document.removeEventListener("mousemove", this.handleDeviceMouseMove);
      document.removeEventListener("mouseup", this.handleDeviceMouseUp);
    },
    handleCancel() {
      // 恢复到初始状态
      this.placedDevices = JSON.parse(
        JSON.stringify(this.initialPlacedDevices)
      );
      this.activeDeviceId = null;
      // 触发取消事件
      this.$emit("cancel");
      // 如果不是嵌入模式，关闭对话框
      if (!this.isEmbedded) {
        this.visible = false;
      }
      // 提示用户已取消
      this.$message({
        message: "已取消修改，已恢复到初始状态",
        type: "info",
      });
    },
    handleModify() {
      // 重置到初始状态，允许重新编辑
      this.placedDevices = JSON.parse(
        JSON.stringify(this.initialPlacedDevices)
      );
      this.activeDeviceId = null;
      // 提示用户已重置
      this.$message({
        message: "已重置到初始状态，可以重新编辑设备位置",
        type: "warning",
      });
    },
    handlePreview() {
      // 将预览配置保存到 sessionStorage
      const previewConfig = {
        backgroundImageUrl: this.backgroundImageUrl,
        centerboxConfig: this.centerboxConfig,
        placedDevices: this.placedDevices,
        backgroundImageId: this.backgroundImageId,
        greenhouseId: this.greenhouseId,
      };
      sessionStorage.setItem(
        "devicePositionPreviewConfig",
        JSON.stringify(previewConfig)
      );

      // 显示全屏iframe预览
      this.previewVisible = true;
    },
    handleClosePreview() {
      this.previewVisible = false;
    },
    handleIframeMessage(event) {
      try {
        const data = event && event.data ? event.data : {};
        if (data && data.type === "DEVICE_PREVIEW_CLOSE") {
          this.previewVisible = false;
        }
      } catch (e) {
        // ignore
      }
    },
    handlePreviewEscKey(event) {
      if (event.key === "Escape" || event.keyCode === 27) {
        this.previewVisible = false;
      }
    },
    handleSave() {
      // 保存设备位置配置
      this.$emit("save", {
        greenhouseId: this.greenhouseId,
        backgroundImageId: this.backgroundImageId,
        backgroundImageUrl: this.backgroundImageUrl,
        devices: this.placedDevices,
        centerboxConfig: this.centerboxConfig,
      });
      if (!this.isEmbedded) {
        this.visible = false;
      }
    },
    handleClose() {
      this.$emit("cancel");
    },
  },
  beforeDestroy() {
    document.removeEventListener("mousemove", this.handleDeviceMouseMove);
    document.removeEventListener("mouseup", this.handleDeviceMouseUp);
    window.removeEventListener("resize", this.updateCanvasSize);
    document.removeEventListener("keydown", this.handlePreviewEscKey);
    window.removeEventListener("message", this.handleIframeMessage);
    // 恢复背景滚动
    document.body.style.overflow = "";
  },
};
</script>

<style scoped lang="less">
.device-position-dialog {
  ::v-deep .el-dialog__body {
    padding: 20px;
    height: 70vh;
    overflow: hidden;
  }
}

.device-position-container {
  &.embedded {
    height: calc(100vh - 300px);
    min-height: 600px;

    .device-position-container-inner {
      height: calc(100% - 60px);
    }

    .embedded-footer {
      position: absolute;
      bottom: 68px;
      right: 430px;
      margin-top: 20px;
      text-align: right;
      padding-top: 15px;
      border-top: 1px solid rgba(255, 255, 255, 0.1);
    }
  }

  height: 100%;

  .canvas-panel {
    width: 100%;
    background: rgba(0, 11, 47, 0.3);
    border-radius: 4px;
    overflow: hidden;
    height: 675px;
    .canvas-container {
      width: 100%;
      height: 100%;
      position: relative;
      overflow: auto;
      padding-left: 60px;
      .background-image {
        /* 背景图按1920x1080的比例适配
           使用aspectRatio: 16/9确保在任何分辨率下都保持正确的比例
           宽度100%自适应容器，高度根据aspectRatio自动计算
           这样设备位置可以基于相对于1920x1080背景图的百分比来保存和显示
           当容器高度不够时，可以通过滚动查看完整背景图，但始终保持16:9比例 */
        width: 100%;
        /* 高度由aspectRatio自动计算，保持16:9比例 */
        position: relative;

        .centerbox {
          position: absolute;
          // 隐藏背景，只保留拖拽区域功能
          background: transparent;

          .placed-device {
            display: flex;
            flex-direction: column;
            align-items: center;
            cursor: move;
            z-index: 10;
            position: absolute;

            &.preview-device {
              cursor: default;
            }

            .device-label {
              position: absolute;
              left: 50%;
              bottom: calc(100% + 8px);
              transform: translate(-50%, 0);
              margin: 0;
              min-width: 90px;
              max-width: 220px;
              padding: 8px 10px;
              font-family: YouSheBiaoTiHei, YouSheBiaoTiHei;
              font-weight: 400;
              font-size: 20px;
              color: #ffffff;
              background: linear-gradient(
                  90deg,
                  rgba(22, 255, 204, 0) 0%,
                  rgba(22, 255, 204, 0.3) 50%,
                  rgba(22, 255, 204, 0) 100%
                ),
                rgba(15, 92, 75, 0.6);
              box-shadow: inset 0px 0px 12px 0px #59fff1;
              letter-spacing: 1px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              user-select: none;
              display: inline-flex;
              align-items: center;
              justify-content: center;
              opacity: 1;
              visibility: visible;
              pointer-events: none;
              max-height: 200px;
            }
            .device-label.long-name {
              min-width: 140px;
              white-space: normal;
              word-break: break-all;
              text-align: center;
              line-height: 1.2;
              max-width: 140px;
            }
            .device-label.is-offline {
              background: linear-gradient(
                  90deg,
                  rgba(255, 84, 84, 0) 0%,
                  rgba(255, 120, 120, 0.5) 50%,
                  rgba(255, 84, 84, 0) 100%
                ),
                rgba(102, 0, 0, 0.6);
              box-shadow: inset 0px 0px 11px 0px #ff824c;
            }

            .device-icon {
              width: 50px;
              height: 50px;
              object-fit: contain;
              filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3));
            }
          }
        }
      }
    }
  }
}

// 全屏iframe预览样式
.fullscreen-iframe-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 2000;
  background-color: rgba(0, 0, 0, 0.9);
  animation: fadeIn 0.3s ease;

  .iframe-container {
    position: relative;
    width: 100%;
    height: 100%;

    .preview-iframe {
      width: 100%;
      height: 100%;
      border: none;
      background: #fff;
    }

    .close-button {
      position: absolute;
      top: 20px;
      right: 20px;
      width: 40px;
      height: 40px;
      background: rgba(0, 0, 0, 0.6);
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      z-index: 10;
      transition: all 0.3s ease;

      &:hover {
        background: rgba(0, 0, 0, 0.8);
        transform: scale(1.1);
      }

      i {
        font-size: 24px;
        color: #fff;
      }
    }
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>
